<template>
    <!-- MODAL PREMIUM -->
    <b-modal ref="modal-premium" id="modal-premium" centered size="xl" :hide-header="screenSize > 575" hide-footer class="modal-box" body-class="p-0" @hide="cleanRoute">

      <b-container fluid  v-if="freeContent" >
        <b-row class="mx-5 my-5 text-center" >
          <h2 class="font-weight-bold mb-0">Are you ready to access all this fantastic content and more for less than 0.55 cents a day?</h2>
        </b-row>
            <!-- BUTTON -->
            <div class="button-purchase-perk mx-5 my-5 text-center">
                <b-button
                  href="https://buy.dropsmart.io/checkout?period=yearly"
                  target="_blank"
                  variant="light"
                  >
                  Click here and upgrade
                  </b-button>
            </div>
      </b-container>
      
      <b-container fluid v-else >
        <b-row :class="screenSize > 992 ? 'mx-5 my-5 text-center' : 'mx-1 my-1 text-center' " >
          <!-- VIDEO CONTENT -->
          <DefaultVideoComponent v-if="videoUrl !== '' " :videoUrl="videoUrl"/>
          <!-- IMAGE CONTENT -->
          <div> 
            <b-img v-if="image !== '' " :src="image" fluid-grow alt="Responsive image" style="border-radius: 2rem;"></b-img>
          </div>
        </b-row>
        <!-- TITLE -->
        <b-row class="mx-5 my-5">
          <h2 class="font-weight-bold mb-0">{{title}}</h2>
        </b-row>

        <b-row class="mx-5 mt-0 mb-5">
          <!-- LEFT COLUMN -->
          <b-col :cols="screenSize > 992 ? 6 : 12" style="padding-left: 0px;">

            <div>
               <!-- SUBTITLE -->
              <p class="font-weight-bold">{{subtitle}}</p>
               <!-- TEXT -->
              <PremiumTextLeftModal />
            </div>
            <!-- BUTTON -->
            <div class="button-purchase-perk" v-if="leftButton !== '' ">
              <!-- <b-link> -->
                <b-button
                  :href="linkDownload"
                  target="_blank"
                  variant="light"
                  >
                  {{leftButton}}
                  </b-button>
                <!-- </b-link> -->
            </div>
          </b-col>

          <!-- RIGHT COLUMN -->
          <b-col :style="screenSize > 992 ? 'padding-right: 0px; padding-left: 50px;' : '' ">

            <div :class="screenSize < 992 ? 'divider' : '' "></div>
            <div v-if="false">
              <p class="font-weight-bold">Reviews</p>
              <div >
               <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
              <div class="mt-3" >
              <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
              <div class="mt-3" >
               <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
            </div>

            <div v-if="true">
              <div class="mb-4">
              <PremiumTextRightModal />
              </div>
              <ReviewForm :rightButton="rightButton" :messageTitle="title"/>
            </div>

          </b-col>
        </b-row>        
      </b-container>
    
    </b-modal>
</template>

<script>
import DefaultVideoComponent from '@/components/centre/DefaultVideoComponent.vue';
import PremiumTextLeftModal from '@/components/centre/premium/PremiumTextLeftModal.vue';
import PremiumTextRightModal from '@/components/centre/premium/PremiumTextRightModal.vue';
import ReviewForm from '@/components/centre/ReviewForm.vue';
import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";

export default {
  name: "PremiumModalComponent",
  components: {
    DefaultVideoComponent,
    PremiumTextLeftModal,
    PremiumTextRightModal,
    ReviewForm,
  },
  props: ["customerInfo", "id", "premiumCardsData", "customerLastSubscription", "showFreeContent"],
  watch: {
    showFreeContent: {
      handler(newValue) {
        // this will be run immediately on component creation.
        this.updateModalContent(newValue);
      },
      // force eager callback execution
      immediate: true
    }
  },
  mounted() {
      this.freeContent = this.showFreeContent;  

      if (this.$route.name === 'Premium' && this.$route.query.id) {
      let id = parseInt(this.$route.query.id);
      let card = this.getCardInfo(id)[0];
      this.title = card.productTitle;
      this.subtitle = card.description;
      this.leftButton = card.leftButton;
      this.rightButton = card.rightButton;
      this.image = card.image;
      this.videoUrl = card.videoUrl;
      this.linkDownload = card.linkDownload;

      if(card.hasModal) {
        this.$refs['modal-premium'].show();
      }
    }

    this.$root.$on("premium-content", (content) => {
      this.title = content.productTitle;
      this.subtitle = content.description;
      this.leftButton = content.leftButton;
      this.rightButton = content.rightButton;
      this.image = content.image;
      this.videoUrl = content.videoUrl;
      this.linkDownload = content.linkDownload;
    });
    this.screenSize = window.innerWidth;
  },
  data() {
    return {
      modernCosmeticsImg: ModernCosmetics,
      videoUrl: "",
      image: "",
      title: "",
      subtitle: "",
      leftButton: "",
      rightButton: "",
      linkDownload: "",
      screenSize: 1024,
      freeContent: null,
    };
  },
  methods: {
    updateModalContent(value) {
      if (value == null) {
        this.freeContent = null;
      } else if (value) {
        this.freeContent = true;
      } else {
        this.freeContent = false;
      }
    },
    cleanRoute() {
      this.$router.push({
        name: "Premium",
        query: { category: this.$route.query.category },
      }).catch(()=>{});
    },
    getCardInfo(id) {
        return this.premiumCardsData.filter((u) => {
          return u.id == id;
        });
    },
  },
};
</script>

<style scoped lang="scss">
div.container-fluid {
  padding: 31px;
}

.button-purchase-perk {
  display: flex;
  justify-content: center;
  button, a.btn {
    font-weight: 700;
    background-color: black; 
    color: #E7E7E7;
    border: none;
    border-radius: 0.4rem;
    padding: 0.5rem 3.5rem 0.5rem 3.5rem;
    margin-top: 1rem;
    &:hover {
      background-color: #E7E7E7;
      color: black; 
    }
  }
}

.divider {
  border: 1px solid #838383;
  margin: 1.4rem 1rem;
}
</style>
